import { di } from 'react-magnetic-di';
import type { FollowUpObject } from '@atlassian/ai-agent-streaming';
import type { ActionSubjectAndAction } from '@atlassian/jira-product-analytics-bridge';
import type { AnalyticsAttributesUntyped } from '@atlassian/jira-product-analytics-bridge/src/types';

const headers = {
	'Content-Type': 'application/json',
	'X-Product': 'jira',
	'X-Experience-Id': 'jira-smart-summary',
};

export const fetchFollowUps = async (
	summary: string,
	fireTrack: (name: ActionSubjectAndAction, id: string, attrs?: AnalyticsAttributesUntyped) => void,
): Promise<FollowUpObject[]> => {
	di(fetch);

	try {
		const response = await fetch(
			'/gateway/api/assist/api/ai/v2/ai-feature/jira/comment-summary/followups',
			{
				method: 'POST',
				credentials: 'include',
				headers,
				body: JSON.stringify({
					ai_feature_input: {
						summary,
					},
				}),
			},
		);

		if (!response.ok) {
			const errorResponse = await response.json();
			throw new Error(errorResponse.errorMessage);
		}

		const data = await response.json();

		return data.ai_feature_output.follow_ups;
	} catch (error) {
		const errorMessage = error instanceof Error ? error.message : 'Unidentified Error';
		fireTrack('aiResult error', 'jiraSmartSummarizeCommentsFollowUpError', {
			error: errorMessage,
			proactiveGeneratedAI: 1,
			userGeneratedAI: 0,
			isProactiveGenerated: true,
		});
		// just return empty array,as we still have our main summary
		return [];
	}
};
